import * as z from 'zod';

const reportSchema = {
  credentialMatrixSchema: () => {
    return z.object({
      payor: z.string().min(1, 'Payor id is required'),
      renProvider: z.string().min(1, 'Payor provider is required'),
      submittedDate: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format (yyyy-MM-dd)'),
      followUpDate: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format (yyyy-MM-dd)'),
      approvalDate: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format (yyyy-MM-dd)'),
      effectiveDate: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format (yyyy-MM-dd)'),
      portalURL: z.string().url().optional(),
    });
  },
  addPayorScheema: () => {
    return z.object({
      companyName: z.string().min(1, 'Payor name is required'),
    });
  },
};

export default reportSchema;
